import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import Loader from 'oxyrion-ui/lib/Loader';
import { connect, actions } from '../../../../Store';
import { __, getIdFromProps } from '../../../../Utils';
import { normalizeParams } from '../../../../Utils/CatalogProductParamsNormalizer';
import { catalogDescTranslate } from '../../CatalogUtils';
import { LoaderWrapper } from '../../../../Components/ReusableComponents';
import Products from '../../Components/Products';
import ProductQuantitySelect from '../../../../Components/ProductQuantitySelect';
import AlertPopup from '../../../../Components/AlertPopup';
import ErrorMessage from '../../../../Components/ErrorMessage';
import DescriptionParamTable from '../../../../Components/DescriptionParamTable';
import FileViewDownload from '../../../../Components/FileViewDownload';
import API2 from '../../../../API2';

const MainWrapper = styled.div`
  padding: ${rem(16)};
  display: flex;
  flex-direction: column-reverse;
  height: 100%;
  background: #fcfcfc;
  justify-content: center;
  ${({ theme }) => theme.media.l`
  flex-direction:row;
`};
`;

const InsideWrapper = styled.div`
  max-width: ${rem(1500)};
  width: 100%;
  display: flex;
  flex-direction: column;
  background: white;
  padding: ${rem(4)};
`;

const Space = styled.div`
  width: ${rem(16)};
  height: ${rem(16)};
`;

const Title = styled.div`
  font-size: ${rem(26)};
  font-weight: 700;
  color: #434245;
  margin-bottom: ${rem(10)};
`;

const ShortDesc = styled.div`
  font-size: ${rem(14)};
  font-weight: 200;
  color: #434245;
  margin-bottom: ${rem(10)};
`;

const Desc = styled.div`
  font-size: ${rem(14)};
  margin-bottom: ${rem(12)};
  margin-top: ${rem(8)};
  color: #434245;
  text-align: justify;
`;

const Line = styled.div`
  height: ${rem(1)};
  width: 100%;
  min-width: ${rem(300)};
  margin-bottom: ${rem(15)};
  background: #434245;
`;

const FileDownloadWrapper = styled.div`
  width: ${rem(200)};
`;

class CatalogProductDetail extends React.Component {
  state = {
    paintSystemLoading: true,
    productsLoading: true,
    paintSystem: {},
    products: [],
  };

  async componentDidMount() {
    const id = getIdFromProps(this.props);
    await this.fetchPaintSystem(id);
    await this.fetchLayersProducts(id);

    actions.setActiveMenuItem('73');
  }

  async fetchPaintSystem(id) {
    try {
      const paintSystem = await API2.getB2BPaintSystemAction(id);

      const params = normalizeParams(paintSystem.params, this.props.appLang);

      if (params && params[0]) {
        params[0].params.push({
          label: __('PDF systému'),
          value: (
            <FileDownloadWrapper>
              <FileViewDownload
                name={__('Zobraziť pdf')}
                history={this.props.history}
                downloadFunction={async () => {
                  return API2.getB2BPaintSystemDownloadAction(id, {
                    type: 'pdf',
                  });
                }}
                error={error => {
                  this.setState({ error });
                }}
              />
            </FileDownloadWrapper>
          ),
        });
      }

      this.setState({
        paintSystem,
        params,
        paintSystemLoading: false,
      });
    } catch (e) {
      this.setState({
        error: __('Náterový systém sa nepodarilo načítať'),
        paintSystemLoading: false,
      });
    }
  }

  async fetchLayersProducts(id) {
    try {
      const response = await API2.getB2BPaintSystemProductsAction(id);
      this.setState({
        products: response.products || [],
        productsLoading: false,
      });
    } catch (e) {
      this.setState({
        error: __('Vrstvy náterového systému sa nepodarilo načítať'),
        paintSystemLoading: false,
      });
    }
  }

  render() {
    const {
      paintSystem,
      products,
      paintSystemLoading,
      productsLoading,
      cartItemsIds,
      cartItems,
      productToAddId,
      showAddToCartProduct,
      showProductAddedPopup,
      error,
      params,
    } = this.state;

    const { appLang } = this.props;

    if (paintSystemLoading) {
      return (
        <LoaderWrapper>
          <Loader size="xl" color="#70af00" />
        </LoaderWrapper>
      );
    }

    return (
      <React.Fragment>
        <ErrorMessage display={error} text={error} />
        <ErrorMessage
          display={showProductAddedPopup}
          success
          text={__('Produkt bol pridaný do objednávky')}
        />

        <MainWrapper>
          <AlertPopup
            display={showAddToCartProduct}
            alignUnderHeader
            onClose={() =>
              this.setState({
                showAddToCartProduct: false,
                productToAddId: undefined,
              })
            }
            component={
              <ProductQuantitySelect
                items={
                  products &&
                  products.find(v => v._id === productToAddId) &&
                  products.find(v => v._id === productToAddId).Unit_of_Measure
                }
                onSubmit={quantity => this.addToCard(quantity)}
              />
            }
          />
          <InsideWrapper>
            <Title>{`${paintSystem.code} - ${
              paintSystem.producer_code
            }`}</Title>
            <ShortDesc>
              {catalogDescTranslate(
                appLang,
                paintSystem.short_description_translation,
                paintSystem.short_description,
              )}
            </ShortDesc>
            <Line />

            <Desc>
              {catalogDescTranslate(
                appLang,
                paintSystem.description_translations,
                paintSystem._description,
              )}
            </Desc>

            <DescriptionParamTable data={params || []} />
            <Space />
            <Title>{__('Produkty')}</Title>
            <Line style={{ margin: 0 }} />
            <Products
              data={products}
              settings={this.props.settings}
              loading={productsLoading}
              cartItemsIds={cartItemsIds}
              cartItems={cartItems}
              variantLoadingId={productToAddId}
              addToCart={productId => this.openAddProductToCard(productId)}
            />
          </InsideWrapper>
        </MainWrapper>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(CatalogProductDetail);



// WEBPACK FOOTER //
// ./src/Containers/ProductCatalog/PaintSystems/Detail/index.jsx